export const validatorCreator = validatorRules => (formFields, formField) => {
  const result = validatorRules.reduce((result, validator) => {
    let errorMessage

    if (!validator.isValid(formField, formFields)) {
      errorMessage = validator.errorMessageCreator ? validator.errorMessageCreator(formField) : validator.errorMessage
    }

    errorMessage && result.push(errorMessage)

    return result
  }, [])

  return result.length ? result[0] : ''
}
